import { render, staticRenderFns } from "./RemoveSessionModal.vue?vue&type=template&id=54a32fc7"
import script from "./RemoveSessionModal.vue?vue&type=script&lang=js"
export * from "./RemoveSessionModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveSessionModal.vue?vue&type=style&index=0&id=54a32fc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports